import App from './components';
import './style';

export default App;

// You can declare additional entry points here. This can be useful for server side rendering component fragments. 
export { App }